import styled from 'styled-components'

export const Container = styled.div`
  min-width: 480px;
  width: 640px;
  margin-top: 15px;
`
